const cards = [
  {
    id: 0,
    name: '-',
    name_esp: '-',
    icon: 'CheckCircleIcon',
    color: '#9B59B6',
    total: 19
  },
  {
    id: 1,
    name: '-',
    name_esp: '-',
    icon: 'CheckCircleIcon',
    color: '#28C76F',
    total: 19
  },
  {
    id: 2,
    name: '-',
    name_esp: '-',
    icon: 'ArrowDownCircleIcon',
    color: '#A6ACAF',
    total: 0
  },
  {
    id: 3,
    name: '-',
    name_esp: '-',
    icon: 'AlertTriangleIcon',
    color: '#FF9F43',
    total: 7
  },
  {
    id: 4,
    name: '-',
    name_esp: '-',
    icon: 'XCircleIcon',
    color: '#BC1300',
    total: 7
  }
]
export default cards
